import _regeneratorRuntime from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\headl\\Documents\\GitHub\\pipeline-ui\\demo\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import algosdk from 'algosdk';

function configClient(_x, _x2, _x3) {
  return _configClient.apply(this, arguments);
}

function _configClient() {
  _configClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(main, api, ref) {
    var paramServer, transServer, fetchObject, params;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            paramServer = '';
            transServer = '';

            if (main) {
              paramServer = 'https://node.algoexplorerapi.io/v2/transactions/params';
              transServer = 'https://node.algoexplorerapi.io/v2/transactions';
            } else {
              paramServer = "https://node.testnet.algoexplorerapi.io/v2/transactions/params";
              transServer = "https://node.testnet.algoexplorerapi.io/v2/transactions";
            }

            if (api) {
              paramServer = ref.algod + "/v2/transactions/params";
              transServer = ref.algod + "/v2/transactions";
            }

            fetchObject = {};

            if (api) {
              fetchObject = {
                method: "GET",
                headers: {
                  'X-Algo-API-Token': ref.token
                }
              };
            }

            _context.next = 8;
            return fetch(paramServer, fetchObject);

          case 8:
            _context.next = 10;
            return _context.sent.json();

          case 10:
            params = _context.sent;

            if (!main) {
              params.genesisID = 'testnet-v1.0';
              params.genesisHash = 'SGO1GKSzyE7IEPItTxCByw9x8FmnrCDexi9/cOUJOiI=';
            } else {
              params.genesisID = 'mainnet-v1.0';
              params.genesisHash = 'wGHE2Pwdvd7S12BL5FaOP20EGYesN73ktiC1qzkkit8=';
            }

            if (api) {
              params.genesisID = ref.devGenId;
              params.genesisHash = ref.devGenHash;
            }

            params.firstRound = params["last-round"];
            params.lastRound = params["last-round"] + 1000;
            return _context.abrupt("return", {
              paramServer: paramServer,
              tranServer: transServer,
              params: params
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _configClient.apply(this, arguments);
}

function configIndexer(main, api, ref) {
  var indexerURL = "";

  if (main) {
    indexerURL = "https://algoindexer.algoexplorerapi.io";
  } else {
    indexerURL = "https://algoindexer.testnet.algoexplorerapi.io";
  }

  if (api) {
    indexerURL = ref.indexer;
  }

  return indexerURL;
}

function sendTxns(_x4, _x5) {
  return _sendTxns.apply(this, arguments);
}

function _sendTxns() {
  _sendTxns = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(txns, transServer) {
    var api,
        token,
        alerts,
        requestHeaders,
        transactionID,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            api = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : false;
            token = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : "";
            alerts = _args2.length > 4 ? _args2[4] : undefined;
            requestHeaders = {
              'Content-Type': 'application/x-binary'
            };

            if (api) {
              requestHeaders = {
                'X-Algo-API-Token': token
              };
            }

            _context2.next = 7;
            return fetch(transServer, {
              method: 'POST',
              headers: requestHeaders,
              body: txns
            }).then(function (response) {
              return response.json();
            }).then(function (data) {
              if (data.txId !== undefined) {
                return data.txId;
              } else {
                if (data.message !== undefined) {
                  if (alerts) {
                    alert(data.message);
                  }

                  return undefined;
                }
              }
            }).catch(function (error) {
              console.error('Error:', error);
            });

          case 7:
            transactionID = _context2.sent;
            return _context2.abrupt("return", transactionID);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _sendTxns.apply(this, arguments);
}

function configAlgosdk(ref) {
  var algodClient = "";

  if (ref.EnableDeveloperAPI) {
    algodClient = new algosdk.Algodv2("", ref.algod, ref.token);
  } else {
    if (!ref.main) {
      algodClient = new algosdk.Algodv2("", 'https://node.testnet.algoexplorerapi.io', '');
    } else {
      algodClient = new algosdk.Algodv2("", 'https://node.algoexplorerapi.io', '');
    }
  }

  return algodClient;
}

export { configClient, configIndexer, sendTxns, configAlgosdk };